var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTabletLandscape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M.662 18.606c0 .845.244 1.522.73 2.03.487.509 1.136.763 1.945.763h17.316c.817 0 1.468-.254 1.955-.763.487-.508.73-1.185.73-2.03V5.38c0-.838-.243-1.51-.73-2.02-.487-.508-1.138-.762-1.955-.762H3.337c-.81 0-1.458.254-1.945.763-.486.508-.73 1.181-.73 2.02v13.225zm1.488-.167V5.58c0-.473.125-.84.376-1.101.25-.262.601-.392 1.053-.392h16.843c.459 0 .811.13 1.058.392.247.261.371.628.371 1.1V18.44c0 .466-.124.83-.37 1.09-.248.262-.6.393-1.059.393H3.58c-.452 0-.803-.131-1.053-.392-.25-.262-.376-.625-.376-1.09zm13.708.642a.428.428 0 00.317-.124.43.43 0 00.123-.317.438.438 0 00-.123-.327.428.428 0 00-.317-.124H8.143a.432.432 0 00-.44.451.432.432 0 00.44.441h7.715z"
  }))));
}

export default SvgTabletLandscape;